import {MoveJourneyMutation} from "./move-journey.mutation";
import {JourneyModel} from "../../../../journey/journey.model";

export class MoveReturnJourneyMutation extends MoveJourneyMutation {
    protected get currentJourneyModel(): JourneyModel | null {
        return this.booking.unfilteredJourneys[1] || null;
    }
}
